import React from 'react';
import { connect } from "react-redux";
import { FormattedMessage, injectIntl  } from 'react-intl';
import Button from '@material-ui/core/Button';
import NumberFormat from 'react-number-format';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import SvgIcon from '@mui/material/SvgIcon';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import { submitHKIDR ,fetchAccountType, fetchCaptcha, fetchCountryList,verifyAccount,fetchConsentStatus,fetchAccountInfo} from "../../redux/actions/hkidrAction.js";
import Compress from 'compress.js';
import queryString from 'query-string';
import Checkbox from '@material-ui/core/Checkbox';
import {Base64} from 'js-base64';
import { Key } from '@mui/icons-material';
import demoChi from '../../Content/images/fileuploaddemo.png';
import demoEn from '../../Content/images/fileuploaddemoen.png';

const RefreshIcon = (props) => (
  <SvgIcon {...props}>
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
  </SvgIcon>
)

const ImgStyle = {
  width: 100,
  marginTop:"20px"
}

const getBase64 = (file, cb)  => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
      cb(reader.result)
  };
  reader.onerror = function (error) {
      console.log('Error: ', error);
  };
}
function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      inputMode="decimal"
    />
  );
}



class HKIDRForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      accountNo: "",
      accountName: "",
      titleWidth: 4,
      inputWidth: 8,
      captcha:"",      
      platform:"companysite",
      consentFilename: "",
      consentFileExtension:"",      
      consentFileIn64: "",
      
      filename: "",
      fileExtension:"",      
      fileIn64: "",

      backsideFilename:"",      
      backsideFileExtension:"",
      backsideFileIn64:"",

      docType:"",
      issuePlace:"",
      issuePlaceText:"",
      
      confirmDialogOpen: false,      
      confirmDialogShowProgress: false,
      fileDemoOpen:false,
      resultOpen:false,
      validation: { 
        invalidAccountId: false,
        invalidAccountName: false,
        invalidCaptcha: false,
        invalidFile: false,
        invalidDocType:false,
        invalidIssuePlace:false,
        invalidConsentFile:false,
        invalidBacksideFile:false,
        maxExceed:false,
        inactiveUser:false,
        invalidConsentFileType:false,
        invalidConsentFileSize:false,
        invalidFileType:false,
        invalidFileSize:false,
        invalidBSFileType:false,
        invalidBSfileSize:false
      },
	    maxJointUpload:5,      
      fileUploadList:[],
      limitFileExtension:["gif","pdf","jpg","jpeg","png"],
      showResultPage:false,
    }
  }
 
  handleAddBtnClick = event => {
    this.clearFileErrorMsg();


    if(this.state.fileUploadList.length == this.state.maxJointUpload){
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,
            maxExceed:true
        }
      }));
      return;
    }

    this.setState(prevState => ({
      validation: {                   
          ...prevState.validation,    
          invalidFile: false,
          invalidDocType:false,
          invalidIssuePlace:false
      }
    }));

    let bIsValid = true;

    if(!this.state.docType){      
      bIsValid= false;
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,    
            invalidDocType: true          
        }
      }));
    }

    if(!this.state.filename){
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,    
            invalidFile :true
        }
      }));
      bIsValid = false;
      document.getElementById("fsfile").style.display = "block";
    }

    if(!this.state.issuePlace){
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,                
            invalidIssuePlace:true
        }
      }));
      bIsValid = false;
    }

    if(this.state.docType == "NTID" && !this.state.backsideFilename){
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,                
            invalidBacksideFile:true
        }
      }));
      bIsValid = false;
      document.getElementById("bsfile").style.display = "block";
    }

    if(!bIsValid){
      return ;
    }

    let arrFileName = this.state.filename.split('.');
    let objDoc = {
      "documentType": this.state.docType,
      "fileContent" : this.state.fileIn64,
      "fileName" : this.state.filename,
      "FileExtension": arrFileName[1],
      "issuePlace": this.state.issuePlace,      
      "bsFileContent": this.state.backsideFileIn64,
      "bsFileExtension": this.state.backsideFilename.split('.')[1],
      "bsFileName" : this.state.backsideFilename,
    };
    this.state.fileUploadList.push(objDoc);    
    this.setState({docType : "", fileIn64:"", filename:"", issuePlace:"", backsideFileIn64:"",backsideFilename:"",backsideFileExtension:""});
    document.getElementById("uploadfile").value ="";
    document.getElementById("uploadBSfile").value ="";
    
  }

  handleConfirmDialogOK = event => {    
    let strDocType = this.state.docType == "NTID" ? "NTIDF": this.state.docType;
    var arrFile = [];
    arrFile.push({
      "fileName":this.state.consentFilename,
      "fileExtension": this.state.consentFileExtension,
      "documentType": "CF",
      "issuePlace": "",
      "fileContent" : this.state.consentFileIn64
    });

    if(this.props.accountType && this.props.accountType.split(',').includes("INDI") || this.props.accountType.split(',').includes("CORP")){
      if(this.state.docType){
        arrFile.push(
          {
            "fileName":this.state.filename,
            "fileExtension": this.state.fileExtension,
            "documentType": strDocType,
            "issuePlace": this.state.issuePlace,
            "fileContent" : this.state.fileIn64
          }
        );
      }
      if(this.state.docType == "NTID") {     
        arrFile.push({
            "fileName":this.state.backsideFilename,
            "fileExtension": this.state.backsideFileExtension,
            "documentType": "NTIDB",
            "IssuePlace": this.state.issuePlaceCode,
            "fileContent" : this.state.backsideFileIn64     
        });
      }
    }

    if(this.props.accountType.split(',').includes("JOIN")){
      for(var i=0; i < this.state.fileUploadList.length; i++){
        let record = this.state.fileUploadList[i];
        if(record.documentType != "NTID"){
          arrFile.push({
            "fileName":record.fileName,
            "fileExtension": record.FileExtension,
            "documentType": record.documentType,
            "IssuePlace": record.issuePlace,
            "fileContent" :record.fileContent  
          });
        }else{
          arrFile.push({
            "fileName":record.fileName,
            "fileExtension": record.FileExtension,
            "documentType": "NTIDF",
            "IssuePlace": record.issuePlace,
            "fileContent" :record.fileContent    
          });

          arrFile.push({
            "fileName":record.bsFileName,
            "fileExtension": record.bsFileExtension,
            "documentType": "NTIDB",
            "IssuePlace": record.issuePlace,
            "fileContent" : record.bsFileContent     
          });
        }
      }
    }


    let objRequest = {
      "strAccountName": this.props.accountInfo.accountName ? this.props.accountInfo.accountName : "",
      "strAccountNo":this.state.accountNo,
      "strCaptcha":this.state.captcha,  
      "attachments" : arrFile,      
    };

    this.setState({confirmDialogShowProgress:true});
    new Promise(
      (resolve) => { resolve(this.props.submitHKIDR(objRequest)) }
    ).then(
      () => {
        this.setState({confirmDialogShowProgress:false, confirmDialogOpen:false, resultOpen:true});      
      }
    );
  }

  clearFileErrorMsg = () =>{
    document.getElementById("consentfile").style.display="none";
    document.getElementById("consenttype").style.display="none";
    document.getElementById("consentsize").style.display="none";
    document.getElementById("fsfile").style.display="none";
    document.getElementById("fstype").style.display="none";
    document.getElementById("fssize").style.display="none";
    document.getElementById("bsfile").style.display="none";
    document.getElementById("bstype").style.display="none";
    document.getElementById("bssize").style.display="none";

    this.setState(prevState => ({
      validation: {                   
          ...prevState.validation,                
          invalidConsentFileType : false,
          invalidConsentFileSize : false,
          invalidFileType : false,
          invalidFileSize : false,
          invalidBSFileType : false,
          invalidBSFileSize : false,
      }
    }));
  }


  handleDeleteFileClick = (index) =>{
    let tempFileUploadList = this.state.fileUploadList;
    tempFileUploadList.splice(index, 1);
    this.setState({ fileUploadList: tempFileUploadList });

    if(this.state.platform == "KGIWebTrade"){   
        window.parent.postMessage({height:document.body.clientHeight}, "*");    
    }
  }

  componentDidMount() {
    if(this.state.platform == "KGIWebTrade"){   
      window.parent.postMessage({height:document.body.clientHeight}, "*");
    }
    this.props.fetchCaptcha();  
  }


  handleAccountNoChange = event =>  {
    this.setState({accountNo : event.target.value});
  }

  handleAccountNameChange = event =>  {
    this.setState({accountName : event.target.value});
  }

  handleCaptchaChange = event =>{
    this.setState({captcha : event.target.value});
  }

  reloadCaptchaClicked = event => {    
    this.props.fetchCaptcha();
  }

  handleVerifyClick= event =>{

    let strAccName = this.state.accountName.trim();
    this.setState({accountName: strAccName });

    let bIsValid = this.state.accountNo && strAccName && this.state.captcha;    
    this.setState(prevState => ({
      validation: {
        ...prevState.validation,    
        invalidAccountId: !this.state.accountNo,  
        invalidAccountName: !strAccName,
        invalidCaptcha : !this.state.captcha
      }
    }));
    

    if(bIsValid){
      let objRequestdata = {
        "strAccountNo" : this.state.accountNo,
        "strAccountName": this.state.accountName,
        "strCaptcha":this.state.captcha
      };
      new Promise(
        (resolve) => { resolve(this.props.verifyAccount(objRequestdata)) }
      ).then(
        () => {        
          if(this.props.verifyAccountResult == 0){
            this.props.fetchConsentStatus(objRequestdata).then(() => {
              this.props.fetchAccountType({"strAccountNo": this.state.accountNo, "strCaptcha":this.state.captcha});
              this.props.fetchCountryList({"strAccountNo": this.state.accountNo, "strCaptcha":this.state.captcha});
              this.props.fetchAccountInfo({"strAccountNo": this.state.accountNo, "strCaptcha":this.state.captcha});
          });
            
          }else{
            this.props.fetchCaptcha();
          }
        }
      );
    }
  }

  handleDocTypeChange = event => {
    this.setState({docType : event.target.value});    
    if(event.target.value == "HKID")
      this.setState({ issuePlace : "HK", issuePlaceText: this.props.intl.locale == "zh-hk" ? this.props.countryList["HK"].description_chinese : this.props.intl.locale == "zh-cn" ? this.props.countryList["HK"].description_sc: this.props.countryList["HK"].description});
    
    if((event.target.value == "NTID" || event.target.value == "PP") && this.state.issuePlace == "HK")
      this.setState({ issuePlace : "", issuePlaceText: ""});
  }

  handleIssuePlaceChange = event => {    
    if(event.target.value != ""){
      this.setState({issuePlace:event.target.value, issuePlaceText: this.props.intl.locale == "zh-hk" ? this.props.countryList[event.target.value].description_chinese : this.props.intl.locale == "zh-cn" ? this.props.countryList[event.target.value].description_sc: this.props.countryList[event.target.value].description});
    }
    else
      this.setState({issuePlace :"", issuePlaceText:""});    
  }

  onUploadConsentBtnClick = () =>{
    document.getElementById('csFile').click();
  }

  onUploadFileBtnClick = () => {
    document.getElementById('uploadfile').click();
  }

  onUploadBackSideBtnClick = () => {
    document.getElementById('uploadBSfile').click();
  }

  handleConsentFileChange= event =>{
    document.getElementById("consentfile").style.display="none";
    document.getElementById("consenttype").style.display="none";
    document.getElementById("consentsize").style.display="none";    

    this.setState(prevState => ({
      validation: {                   
          ...prevState.validation,                
          invalidConsentFileType : false,
          invalidConsentFileSize : false,
      }
    }));

    if(!event.target.files[0]){
      this.setState({consentFilename: "",consentFileExtension:"",consentFileIn64: ""});
      document.getElementById("csFile").value = "";      
      return;
    }

    let fileName = event.target.files[0].name;
    let fileExtension = fileName.split('.').pop();

    if(!this.state.limitFileExtension.includes(fileExtension.toLowerCase())){
      this.setState({consentFilename: "", consentFileExtension: "",consentFileIn64:"" }); 
      document.getElementById("csFile").value ="";      
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,                
            invalidConsentFileType : true,
        }
      }));
      document.getElementById("consenttype").style.display="block";    
      return;
    }

    if(event.target.files[0].size > (10*1024*1024)){
      this.setState({consentFilename: "", consentFileExtension: "",consentFileIn64:"" }); 
      document.getElementById("csFile").value ="";      
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,                
            invalidConsentFileSize : true,
        }
      }));
      document.getElementById("consentsize").style.display="block";
      return;
    }

    this.setState({consentFilename: fileName,consentFileExtension:fileExtension});
    if(fileExtension.toUpperCase() == "PDF" ){
      getBase64(event.target.files[0], (result) => {
        if (result) {
          this.setState({consentFileIn64: result.split(',')[1]});
        }
      });
    } else {    
      if (fileName.length > 24) {
        fileName = "..." + fileName.slice(fileName.length - 20)
      }
      
      const compress = new Compress()
      compress.compress([...event.target.files], {
        size: 2,        // the max size in MB, defaults to 2MB
        quality: .75,     // the quality of the image, max is 1,
        maxWidth: 1920,   // the max width of the output image, defaults to 1920px
        maxHeight: 1920,  // the max height of the output image, defaults to 1920px
        resize: true,     // defaults to true, set false if you do not want to resize the image width and height
      }).then((results) => {
        this.setState({consentFileIn64: results[0].data})
      });
    }
  }

  handleFileChange = event=>{
    document.getElementById("fsfile").style.display="none";
    document.getElementById("fstype").style.display="none";
    document.getElementById("fssize").style.display="none";

    this.setState(prevState => ({
      validation: {
          ...prevState.validation,                
          invalidFileType : false,
          invalidFileSize : false
      }
    }));

    if(!event.target.files[0]){      
      this.setState({filename: "",fileExtension:"",fileIn64: null});
      document.getElementById("uploadfile").value ="";      
      return;
    }

    let fileName = event.target.files[0].name;
    let fileExtension = fileName.split('.').pop();

    if(!this.state.limitFileExtension.includes(fileExtension.toLowerCase())){
      this.setState({filename: "", fileExtension: "",fileIn64:"" }); 
      document.getElementById("uploadfile").value ="";      
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,                
            invalidFileType : true,
        }
      }));
      document.getElementById("fstype").style.display="block";    
      return;
    }

    if(event.target.files[0].size > (10*1024*1024)){
      this.setState({filename: "", fileExtension: "",fileIn64:"" }); 
      document.getElementById("uploadfile").value ="";
      
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,                
            invalidFileSize : true,
        }
      }));
      document.getElementById("fssize").style.display="block";
      return;
    }

    this.setState({filename: fileName,fileExtension:fileExtension});
    if(fileExtension.toUpperCase() == "PDF" ){
      getBase64(event.target.files[0], (result) => {
        if (result) {
          this.setState({fileIn64: result.split(',')[1]});
        }
      });
    } else {  
      if (fileName.length > 24) {
        fileName = "..." + fileName.slice(fileName.length - 20)
      }      
      const compress = new Compress()
      compress.compress([...event.target.files], {
        size: 2,        // the max size in MB, defaults to 2MB
        quality: .75,     // the quality of the image, max is 1,
        maxWidth: 1920,   // the max width of the output image, defaults to 1920px
        maxHeight: 1920,  // the max height of the output image, defaults to 1920px
        resize: true,     // defaults to true, set false if you do not want to resize the image width and height
      }).then((results) => {
        this.setState({fileIn64: results[0].data})
      });
    }
  }

  handleBackSideFileChange = event =>{

    document.getElementById("bsfile").style.display="none";
    document.getElementById("bstype").style.display="none";
    document.getElementById("bssize").style.display="none";

    this.setState(prevState => ({
      validation: {                   
          ...prevState.validation,                
          invalidBSFileType : false,
          invalidBSFileSize : false,
      }
    }));

    if(!event.target.files[0]){      
      this.setState({backsideFilename: "",backsideFileExtension:"",backsideFileIn64: null});
      document.getElementById("uploadBSfile").value ="";      
      return;
    }


    let fileName = event.target.files[0].name;
    let fileExtension = fileName.split('.').pop();
    if(!this.state.limitFileExtension.includes(fileExtension.toLowerCase())){
      this.setState({backsideFilename: "", backsideFileExtension: "",backsideFileIn64:"" }); 
      document.getElementById("uploadBSfile").value ="";      
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,                
            invalidBSFileType : true,
        }
      }));
      document.getElementById("bstype").style.display  = "block";
      return;
    }

    if(event.target.files[0].size > (10*1024*1024)){
      this.setState({backsideFilename: "", backsideFileExtension: "",backsideFileIn64:"" }); 
      document.getElementById("uploadBSfile").value ="";
      
      this.setState(prevState => ({
        validation: {                   
            ...prevState.validation,                
            invalidBSFileSize : true,
        }
      }));
      document.getElementById("bssize").style.display  = "block";
      return;
    }
    
    this.setState({backsideFilename: fileName,backsideFileExtension:fileExtension});
    if(fileExtension.toUpperCase() == "PDF" ){
      getBase64(event.target.files[0], (result) => {
        if (result) {
          this.setState({backsideFileIn64: result.split(',')[1]});
        }
      });
    } else {  
      if (fileName.length > 24) {
        fileName = "..." + fileName.slice(fileName.length - 20)
      }
      const compress = new Compress()
      compress.compress([...event.target.files], {
        size: 2,        // the max size in MB, defaults to 2MB
        quality: .75,     // the quality of the image, max is 1,
        maxWidth: 1920,   // the max width of the output image, defaults to 1920px
        maxHeight: 1920,  // the max height of the output image, defaults to 1920px
        resize: true,     // defaults to true, set false if you do not want to resize the image width and height
      }).then((results) => {
        this.setState({backsideFileIn64: results[0].data})
      });
    }
  }

  onSampleClick = event => {    
    this.setState({fileDemoOpen:true});
  }

  handleDemoDialogClose = event =>{
    this.setState({fileDemoOpen:false});
  }

  handleConfirmDialogCancel = event =>{
    this.setState({confirmDialogOpen:false});
  }

  handleSubmitClick = event => {
    this.clearFileErrorMsg(); 
    let bIsNoAccInfoUpload = !this.state.docType && !this.state.issuePlace && !this.state.filename;
    let bIsValid = true;
    if(this.props.accountType && this.props.accountType.split(',').includes("INDI")){
      this.setState(prevState => ({
        validation: {
            ...prevState.validation,    
            invalidConsentFile: !this.state.consentFilename,
            invalidDocType: !this.state.docType && !bIsNoAccInfoUpload,
            invalidFile : !this.state.filename && !bIsNoAccInfoUpload,
            invalidIssuePlace:!this.state.issuePlace && !bIsNoAccInfoUpload,
            invalidBacksideFile: (this.state.docType == "NTID" && !this.state.backsideFilename) && !bIsNoAccInfoUpload
        }
      }));

      if(!this.state.consentFilename)
        document.getElementById("consentfile").style.display="block";
      
      if(!this.state.filename && !bIsNoAccInfoUpload)
        document.getElementById("fsfile").style.display="block";

      if((this.state.docType == "NTID" && !this.state.backsideFilename) && !bIsNoAccInfoUpload)
        document.getElementById("bsfile").style.display="block";
  
      
      bIsValid = this.state.consentFilename && (bIsNoAccInfoUpload || (!bIsNoAccInfoUpload && this.state.docType && this.state.filename && this.state.issuePlace));
      if(bIsValid && this.state.docType == "NTID"){
        bIsValid = this.state.backsideFilename;
      }


      if(bIsValid){
        this.setState({confirmDialogOpen:true});
      }

    }
    else if(this.props.accountType && this.props.accountType.includes("CORP")){      

      this.setState(prevState => ({
        validation: {
            ...prevState.validation,
            invalidConsentFile: !this.state.consentFilename,
            invalidDocType: !this.state.docType && !bIsNoAccInfoUpload,            
            invalidIssuePlace:!this.state.issuePlace && !bIsNoAccInfoUpload,
            invalidFile : !this.state.filename && !bIsNoAccInfoUpload,
        }
      }));

      if(!this.state.consentFilename)
        document.getElementById("consentfile").style.display="block";

      bIsValid = this.state.consentFilename && (bIsNoAccInfoUpload || (!bIsNoAccInfoUpload && this.state.docType && this.state.filename && this.state.issuePlace));
      if(bIsValid){
        this.setState({confirmDialogOpen:true});
      }
    }
    else if(this.props.accountType && this.props.accountType.includes("JOIN")){      
      this.setState(prevState => ({
        validation: {
            ...prevState.validation,    
            invalidConsentFile: !this.state.consentFilename
        }
      }));

      if(!this.state.consentFilename)
        document.getElementById("consentfile").style.display="block";
      else
        this.setState({confirmDialogOpen:true});      
    }
  };

  handleResultDialogClose = event =>{
    this.setState({resultOpen:false});
    if(this.props.submitResult){
      this.setState({showResultPage:true});
    }
    
  }

  render() {
    const { intl } = this.props;    
    return (
      <div>

        {/*Pre-Login */}
        {
          this.props.verifyAccountResult != 0 &&
          <Grid container spacing={2} style={{fontFamily: "Roboto, Helvetica, Arial, sans-serif"}}>
            <Grid item xs={this.state.titleWidth}>
              <span><FormattedMessage id="hkidr.accountId" /></span>
            </Grid>
            <Grid item xs={this.state.inputWidth}>
              <TextField
                error={this.state.validation.invalidAccountId}
                helperText={this.state.validation.invalidAccountId ? intl.formatMessage({id: "hkidr.invalidAccountId"}) : ""}
                className="inputbox"
                value={this.state.accountNo} 
                onChange={this.handleAccountNoChange} 
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              />
            </Grid>

            <Grid item xs={this.state.titleWidth}>
              <span><FormattedMessage id="hkidr.accountName" /></span>
            </Grid>
            <Grid item xs={this.state.inputWidth}>
              <TextField
                error={this.state.validation.invalidAccountName}
                helperText={this.state.validation.invalidAccountName ? intl.formatMessage({id: "hkidr.invalidAccountName"}) : ""}
                className="inputbox"
                value={this.state.accountName} 
                onChange={this.handleAccountNameChange}
              />         
            </Grid>


            <Grid item xs={this.state.titleWidth}>
              <span><FormattedMessage id="hkidr.captcha" /></span>
            </Grid>
            <Grid item xs={this.state.inputWidth}>
              <div>
              <TextField
                error={this.state.validation.invalidCaptcha}
                helperText={this.state.validation.invalidCaptcha ? intl.formatMessage({id: "hkidr.invalidCaptcha"}) : ""}
                className="inputbox"
                value={this.state.captcha} 
                onChange={this.handleCaptchaChange}
              />
              </div>
              <div>
                <img style={ImgStyle} src={"data:image/png;base64," + this.props.captcha} />
                <RefreshIcon className="reloadCaptcha" onClick={this.reloadCaptchaClicked}/>
              </div>
            </Grid>
            <Grid item xs={12}>
            <span style={{color:"red"}}><FormattedMessage id={"hkidr.verifyErr_" + this.props.verifyAccountResult} /></span>
            </Grid>

            <Grid item xs={12}>
              <Button variant="contained" color="primary" onClick={this.handleVerifyClick}><FormattedMessage id="general.submit" /></Button>
            </Grid>
          </Grid>
        }

        {
          this.props.verifyAccountResult == 0 && this.props.accountTypeCompleted && !this.state.showResultPage &&  !(this.props.accountType.split(',').includes("INDI") ||this.props.accountType.split(',').includes("JOIN")||this.props.accountType.split(',').includes("CORP")) && 
          <span>You are not required to fill this form.</span>
        }


        {/*Check consent*/}
        {
          this.props.consentStatusCompleted && !this.props.notConsent &&
          <div>
            <span><FormattedMessage id="hkidr.consented" /></span> 
          </div>
        }

        {
          this.props.verifyAccountResult  == 0 && this.props.consentStatusCompleted && this.props.notConsent && !this.state.showResultPage && (this.props.accountType.split(',').includes("INDI") ||this.props.accountType.split(',').includes("JOIN")||this.props.accountType.split(',').includes("CORP")) &&
            <Grid container spacing={2} style={{fontFamily: "Roboto, Helvetica, Arial, sans-serif"}}>            
            {
              (this.props.accountType.split(',').includes("JOIN") || this.props.accountType.split(',').includes("INDI") || this.props.accountType.split(',').includes("CORP"))  && 
              <React.Fragment>
                <Grid item xs={this.state.titleWidth}>
                  <div>
                    <span><FormattedMessage id="hkidr.uploadconsent" /></span>
                  </div>
                </Grid>                
                <Grid item xs={this.state.inputWidth}>
                  <React.Fragment>
                    <FormControl error={this.state.validation.invalidConsentFile} style={{width:"100%"}}>
                      <input type="file" id="csFile" accept=".png,.gif,.jpeg,.jpg,.pdf" key={this.state.fileKey} onChange={this.handleConsentFileChange} style={{display: 'none'}} />
                      <div className="webUploadBtn" onClick={this.onUploadConsentBtnClick} style={{width:"100%"}}>
                        <div className="uploadBoxFileName">
                          <span style={{marginLeft:"2px",maxWidth:"calc(100% - 8px)", wordBreak:"break-all"}}>{ this.state.consentFilename }</span>
                        </div> 
                        <div className="uploadBoxBtn">
                          <span><FormattedMessage id="hkidr.browse" /></span>
                        </div>
                        <div style={{clear: "both"}}></div>
                      </div>
                      <FormHelperText style={{color:"red",display:"none"}} id="consentfile">{this.state.validation.invalidConsentFile ? intl.formatMessage({id: "hkidr.invalidFile"}) : ""}</FormHelperText>                  
                      <FormHelperText style={{color:"red",display:"none"}} id="consenttype">{this.state.validation.invalidConsentFileType ? intl.formatMessage({id: "hkidr.invalidFileType"}) : ""}</FormHelperText>                  
                      <FormHelperText style={{color:"red",display:"none"}} id="consentsize">{this.state.validation.invalidConsentFileSize ? intl.formatMessage({id: "hkidr.invalidFileSize"}) : ""}</FormHelperText>                  
                    </FormControl>
                    <div>
                      {
                        (this.props.accountType.split(',').includes("JOIN") || this.props.accountType.split(',').includes("INDI"))  && 
                        <a href="https://acc.kgi.com.hk/hkidr/form/indiv" target="_blank"><FormattedMessage id="hkidr.donwloadconsent" /></a>  
                      }                      
                      {
                        this.props.accountType.split(',').includes("CORP") &&
                        <a href="https://acc.kgi.com.hk/hkidr/form/corp" target="_blank"><FormattedMessage id="hkidr.donwloadconsent" /></a>
                      }
                    </div>
                  </React.Fragment>                  
                </Grid>
                <hr style={{width:"100%"}} />
              </React.Fragment>
            }


            {/* Upload Document Part */}
            {
              this.props.accountType != "" && this.props.consentStatusCompleted && this.props.notConsent &&  !this.state.showResultPage && (this.props.accountType.split(',').includes("CORP") || this.props.accountType.split(',').includes("INDI")) && 
              <React.Fragment>                
                <Grid item xs={12} style={{marginBottom:"20px"}}><span><FormattedMessage id="hkidr.uploadFileNotice" /></span></Grid>
                <Grid item xs={this.state.titleWidth}>           
                  <FormattedMessage id="hkidr.docType" />
                </Grid>

                <Grid item xs={this.state.inputWidth}>
                  <React.Fragment>
                    <FormControl error={this.state.validation.invalidDocType} className="inputbox">
                    {this.props.accountType && this.props.accountType.includes("INDI") &&
                      <Select
                        value={this.state.docType}                                   
                        onChange={this.handleDocTypeChange}
                        className="ddlDocType"
                      >                        
                          <MenuItem value={""}>&nbsp;</MenuItem>
                          <MenuItem value={"HKID"}><FormattedMessage id="hkidr.HKID" /></MenuItem>                                            
                          <MenuItem value={"NTID"}><FormattedMessage id="hkidr.NTID" /></MenuItem>
                          <MenuItem value={"PP"}><FormattedMessage id="hkidr.PP" /></MenuItem>
                        </Select>
                    }
                    {
                      this.props.accountType && this.props.accountType.includes("CORP") &&
                      <div>
                      <Select
                        value={this.state.docType}                                   
                        onChange={this.handleDocTypeChange}
                        className="ddlDocType"
                      >                        
                          <MenuItem value={""}>&nbsp;</MenuItem>
                          <MenuItem value={"LEI"}><FormattedMessage id="hkidr.LEI" /></MenuItem>                  
                          <MenuItem value={"COI"}><FormattedMessage id="hkidr.COI" /></MenuItem>
                          <MenuItem value={"BRC"}><FormattedMessage id="hkidr.BRC" /></MenuItem>                                          
                          <MenuItem value={"OTHS"}><FormattedMessage id="hkidr.OTHS" /></MenuItem>                                          
                        </Select>
                        </div>
                    }
                        <FormHelperText style={{color:"red"}}>{this.state.validation.invalidDocType ? intl.formatMessage({id: "hkidr.invalidDocType"}) : ""}</FormHelperText>  
                    </FormControl>
                  </React.Fragment>
                </Grid>
                <Grid item xs={this.state.titleWidth}>
                    <FormattedMessage id="hkidr.idIssuePlace" />
                </Grid>
                <Grid item xs={this.state.inputWidth}>
                <FormControl error={this.state.validation.invalidIssuePlace} className="inputbox">              
                    <Select
                        value={this.state.issuePlace}
                        onChange={this.handleIssuePlaceChange}
                        className="ddlDocType"
                        disabled={this.state.docType == "HKID"}                                             
                      >
                        <MenuItem value={""}>&nbsp;</MenuItem>
                        {
                          this.props.countryList != null &&
                            Object.entries(this.props.countryList).map(([key,record]) => (
                              key == "HK" ? 
                              <MenuItem key={key} value={key} disabled={this.state.docType=="NTID" || this.state.docType=="PP" }>{  intl.locale == "zh-hk" ?  record.description_chinese : intl.locale == "zh-cn" ? record.description_sc : record.description}</MenuItem>
                              :
                              <MenuItem key={key} value={key}>{  intl.locale == "zh-hk" ?  record.description_chinese : intl.locale == "zh-cn" ? record.description_sc : record.description}</MenuItem>
                            ))
                        }
                    </Select>
                    <FormHelperText style={{color:"red"}}>{this.state.validation.invalidIssuePlace ? intl.formatMessage({id: "hkidr.invalidIssuePlace"}) : ""}</FormHelperText>
                    
                </FormControl>
                </Grid>
                
                <Grid item xs={this.state.titleWidth}>
                    <FormattedMessage id={this.state.docType == "NTID" ? "hkidr.NTIDF" : "hkidr.doc"} />
                </Grid>
                <Grid item xs={this.state.inputWidth}>
                  <React.Fragment>
                    <FormControl error={this.state.validation.invalidFile}>                     
                      <input type="file" id="uploadfile" accept=".png,.gif,.jpeg,.jpg,.pdf" onChange={this.handleFileChange} style={{display: 'none'}} />
                      <div className="webUploadBtn" onClick={this.onUploadFileBtnClick}>
                        <div className="uploadBoxFileName">
                          <span style={{marginLeft:"2px"}}>{ this.state.filename }</span>
                        </div>
                        <div className="uploadBoxBtn">
                          <span><FormattedMessage id="hkidr.browse" /></span>
                        </div>
                        <div style={{clear: "both"}}></div>
                      </div>
                      <FormHelperText style={{color:"red",display:"none"}} id="fsfile">{this.state.validation.invalidFile ? intl.formatMessage({id: "hkidr.invalidFile"}) : ""}</FormHelperText>
                      <FormHelperText style={{color:"red",display:"none"}} id="fstype">{this.state.validation.invalidFileType ? intl.formatMessage({id: "hkidr.invalidFileType"}) : ""}</FormHelperText>
                      <FormHelperText style={{color:"red",display:"none"}} id="fssize">{this.state.validation.invalidFileSize ? intl.formatMessage({id: "hkidr.invalidFileSize"}) : ""}</FormHelperText> 
                      {
                        (this.props.accountType.split(',').includes("JOIN") || this.props.accountType.split(',').includes("INDI")) &&
                        <div style={{width:"264px"}}>
                          <span style={{wordBreak:"break-word"}}><FormattedMessage id="hkidr.fileinstruction" /></span>
                          <span style={{width:"264px",wordBreak:"break-word", cursor:"pointer", color:"blue",textDecoration:"underline"}} onClick={this.onSampleClick}>(<FormattedMessage id="hkidr.sample" />)</span>                        
                        </div>
                      }
                    </FormControl>
                  </React.Fragment>
                </Grid>
                
                <Grid item xs={this.state.titleWidth} className={this.state.docType == "NTID" ? "show" : "hidden"} >
                  <FormattedMessage id="hkidr.NTIDB" />
                </Grid>
                <Grid item xs={this.state.inputWidth} className={this.state.docType == "NTID" ? "show" : "hidden"} >
                  <React.Fragment>                
                    <FormControl error={this.state.validation.invalidFile}>                
                      <input type="file" id="uploadBSfile" accept=".png,.gif,.jpeg,.jpg,.pdf" onChange={this.handleBackSideFileChange} style={{display: 'none'}} />
                      <div className="webUploadBtn" onClick={this.onUploadBackSideBtnClick}>
                        <div className="uploadBoxFileName">
                          <span style={{marginLeft:"2px"}}>{ this.state.backsideFilename }</span>
                        </div>
                        <div className="uploadBoxBtn">
                          <span><FormattedMessage id="hkidr.browse" /></span>
                        </div>
                        <div style={{clear: "both"}}></div>
                      </div>                                       
                      <FormHelperText style={{color:"red",display:"none"}} id="bsfile">{this.state.validation.invalidBacksideFile ? intl.formatMessage({id: "hkidr.invalidFile"}) : ""}</FormHelperText>
                      <FormHelperText style={{color:"red",display:"none"}} id="bstype">{this.state.validation.invalidBSFileType ? intl.formatMessage({id: "hkidr.invalidFileType"}) : ""}</FormHelperText>                  
                      <FormHelperText style={{color:"red",display:"none"}} id="bssize">{this.state.validation.invalidBSFileSize ? intl.formatMessage({id: "hkidr.invalidFileSize"}) : ""}</FormHelperText>   
                    </FormControl>
                  </React.Fragment>
                </Grid>
                <Grid item xs={12}>
              <Button variant="contained" color="primary" onClick={this.handleSubmitClick}><FormattedMessage id="general.submit" /></Button>
            </Grid>
              </React.Fragment>
            }

            {/* JOINT Account Section */}
            {
              this.props.accountType != "" && this.props.consentStatusCompleted && this.props.notConsent &&  !this.state.showResultPage && this.props.accountType.split(',').includes("JOIN") && 
              <React.Fragment>
                <Grid item xs={12} style={{marginBottom:"20px"}}><span><FormattedMessage id="hkidr.uploadFileNotice" /></span></Grid>
                <Grid item xs={this.state.titleWidth}>           
                  <FormattedMessage id="hkidr.docType" />
                </Grid>

                <Grid item xs={this.state.inputWidth}>
                  <React.Fragment>
                    <FormControl error={this.state.validation.invalidDocType} className="inputbox">                   
                      <Select
                        value={this.state.docType}                                   
                        onChange={this.handleDocTypeChange}
                        className="ddlDocType"
                      >                        
                          <MenuItem value={""}>&nbsp;</MenuItem>
                          <MenuItem value={"HKID"}><FormattedMessage id="hkidr.HKID" /></MenuItem>                                            
                          <MenuItem value={"NTID"}><FormattedMessage id="hkidr.NTID" /></MenuItem>
                          <MenuItem value={"PP"}><FormattedMessage id="hkidr.PP" /></MenuItem>
                        </Select>
                        <FormHelperText>{this.state.validation.invalidDocType ? intl.formatMessage({id: "hkidr.invalidDocType"}) : ""}</FormHelperText>
                    </FormControl>
                  </React.Fragment>
                </Grid>
                <Grid item xs={this.state.titleWidth}>
                    <FormattedMessage id="hkidr.idIssuePlace" />
                </Grid>
                <Grid item xs={this.state.inputWidth}>
                <FormControl error={this.state.validation.invalidIssuePlace} className={"inputbox " + this.state.docType}>
                    <Select
                        value={this.state.issuePlace}
                        onChange={this.handleIssuePlaceChange}
                        className="ddlDocType"
                        disabled={this.state.docType == "HKID"}                                             
                      >
                        <MenuItem value={""}>&nbsp;</MenuItem>
                        {
                          this.props.countryList != null &&
                            Object.entries(this.props.countryList).map(([key,record]) => (
                              key == "HK" ? 
                              <MenuItem key={key} value={key} disabled={this.state.docType=="NTID" || this.state.docType=="PP" }>{  intl.locale == "zh-hk" ?  record.description_chinese : intl.locale == "zh-cn" ? record.description_sc : record.description}</MenuItem>
                              :
                              <MenuItem key={key} value={key}>{  intl.locale == "zh-hk" ?  record.description_chinese : intl.locale == "zh-cn" ? record.description_sc : record.description}</MenuItem>
                            ))
                        }
                    </Select>
                    <FormHelperText>{this.state.validation.invalidIssuePlace ? intl.formatMessage({id: "hkidr.invalidIssuePlace"}) : ""}</FormHelperText>
                </FormControl>
                </Grid>

                <Grid item xs={this.state.titleWidth}>
                    <FormattedMessage id={this.state.docType == "NTID" ? "hkidr.NTIDF" : "hkidr.doc"} />
                </Grid>
                <Grid item xs={this.state.inputWidth}>
                  <React.Fragment>
                    <FormControl error={this.state.validation.invalidFile}>                     
                      <input type="file" id="uploadfile" accept=".png,.gif,.jpeg,.jpg,.pdf" onChange={this.handleFileChange} style={{display: 'none'}} />
                      <div className="webUploadBtn" onClick={this.onUploadFileBtnClick}>
                        <div className="uploadBoxFileName">
                          <span style={{marginLeft:"2px"}}>{ this.state.filename }</span>
                        </div>
                        <div className="uploadBoxBtn">
                          <span><FormattedMessage id="hkidr.browse" /></span>
                        </div>
                        <div style={{clear: "both"}}></div>
                      </div>                      
                      <FormHelperText style={{color:"red",display:"none"}} id="fsfile">{this.state.validation.invalidFile ? intl.formatMessage({id: "hkidr.invalidFile"}) : ""}</FormHelperText>
                      <FormHelperText style={{color:"red",display:"none"}} id="fstype">{this.state.validation.invalidFileType ? intl.formatMessage({id: "hkidr.invalidFileType"}) : ""}</FormHelperText>
                      <FormHelperText style={{color:"red",display:"none"}} id="fssize">{this.state.validation.invalidFileSize ? intl.formatMessage({id: "hkidr.invalidFileSize"}) : ""}</FormHelperText> 
                      <div style={{width:"264px"}}>
                        <span style={{wordBreak:"break-word"}}><FormattedMessage id="hkidr.fileinstruction" /></span>
                        <span style={{width:"264px",wordBreak:"break-word", cursor:"pointer", color:"blue",textDecoration:"underline"}} onClick={this.onSampleClick}>(<FormattedMessage id="hkidr.sample" />)</span>                        
                      </div>
                    </FormControl>
                  </React.Fragment>
                </Grid>
                
                <Grid item xs={this.state.titleWidth} className={this.state.docType == "NTID" ? "show" : "hidden"} >
                  <FormattedMessage id="hkidr.NTIDB" />
                </Grid>
                <Grid item xs={this.state.inputWidth} className={this.state.docType == "NTID" ? "show" : "hidden"} >
                  <React.Fragment>                
                    <FormControl error={this.state.validation.invalidFile}>                
                      <input type="file" id="uploadBSfile" accept=".png,.gif,.jpeg,.jpg,.pdf" key={this.state.fileKey} onChange={this.handleBackSideFileChange} style={{display: 'none'}} />
                      <div className="webUploadBtn" onClick={this.onUploadBackSideBtnClick}>
                        <div className="uploadBoxFileName">
                          <span style={{marginLeft:"2px"}}>{ this.state.backsideFilename }</span>
                        </div>
                        <div className="uploadBoxBtn">
                          <span><FormattedMessage id="hkidr.browse" /></span>
                        </div>
                        <div style={{clear: "both"}}></div>
                      </div>                                       
                      <FormHelperText style={{color:"red",display:"none"}} id="bsfile">{this.state.validation.invalidBacksideFile ? intl.formatMessage({id: "hkidr.invalidFile"}) : ""}</FormHelperText>
                      <FormHelperText style={{color:"red",display:"none"}} id="bstype">{this.state.validation.invalidBSFileType ? intl.formatMessage({id: "hkidr.invalidFileType"}) : ""}</FormHelperText>                  
                      <FormHelperText style={{color:"red",display:"none"}} id="bssize">{this.state.validation.invalidBSFileSize ? intl.formatMessage({id: "hkidr.invalidFileSize"}) : ""}</FormHelperText>   
                    </FormControl>
                  </React.Fragment>
                </Grid>
                

                <Grid item xs={12}>
                <Button variant="contained" color="primary" onClick={this.handleAddBtnClick}><FormattedMessage id="hkidr.add" /></Button>
                <FormHelperText style={{color:"red"}}>{this.state.validation.maxExceed ? intl.formatMessage({id: "hkidr.maxexceed"}) : ""}</FormHelperText>
              </Grid>

              <hr style={{width:"100%"}} />
              <Grid item xs={12}>
                        <TableContainer>
                            <Table aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b><FormattedMessage id="hkidr.docType" /></b></TableCell>
                                        <TableCell><b><FormattedMessage id="hkidr.doc" /></b></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        this.state.fileUploadList.map((record, index) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <span><FormattedMessage id={"hkidr." +record.documentType} /></span>
                                                </TableCell>
                                                <TableCell>
                                                  <div>{record.fileName}</div>
                                                  {
                                                    record.documentType == "NTID" &&
                                                      <div>{record.bsFileName}</div>
                                                  }
                                                  </TableCell>
                                                <TableCell>
                                                    <IconButton onClick={() => this.handleDeleteFileClick(index)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                </Grid>
                <Grid item xs={12}>
                  <Button variant="contained" color="primary" onClick={this.handleSubmitClick}><FormattedMessage id="general.submit" /></Button>
                </Grid>

              </React.Fragment>
            }


          {/* file upload demo dialog */}
          <Dialog
            disableBackdropClick
            disableEscapeKeyDown
            open={this.state.fileDemoOpen}
          >
            <DialogTitle>              
              <FormattedMessage id="hkidr.sample" />
            </DialogTitle>
            <DialogContent dividers>
              <div style={{width:"100%", minWidth:"263px"}}>
                <div style={{width:"263px",margin:"auto"}}>
                  <img src={intl.locale != "en" ? demoChi : demoEn } alt="demo" style={{width:"263px", maxWidth:"263px"}} />
                </div>            
                </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDemoDialogClose} color="primary">
                <FormattedMessage id="general.close" />
              </Button>
            </DialogActions>
            { 
              this.state.confirmDialogShowProgress && 
              <div style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
                <CircularProgress />
              </div>
            }
          </Dialog>

        {/*confirmation dialog */}
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={this.state.confirmDialogOpen}
        >
          <DialogTitle>              
            <FormattedMessage id="general.confirmation" />
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2} style={{fontFamily: "Roboto, Helvetica, Arial, sans-serif"}}>
              <Grid item xs={6}>
                <span><FormattedMessage id="hkidr.accountNo" />:</span>
              </Grid>
              <Grid item xs={6}>
                <span>{this.state.accountNo}</span>
              </Grid>

              {
                this.props.accountType && !this.props.accountType.split(',').includes("CORP") &&
                <React.Fragment>
                  <Grid item xs={6}>
                    <span><FormattedMessage id="hkidr.CONSENT" />:</span>
                  </Grid>
                  <Grid item xs={6}>
                    <span>{this.state.consentFilename}</span>
                  </Grid>
                </React.Fragment>
              }

              <Grid item xs={6}>
                <span><FormattedMessage id="hkidr.requestUpdate" />:</span>
              </Grid>
              <Grid item xs={6}>
                {
                  this.props.accountType.split(',').includes("JOIN") ? this.state.fileUploadList.length > 0 ?  intl.formatMessage({id: "hkidr.yes"}) : intl.formatMessage({id: "hkidr.no"}) : this.state.filename ? intl.formatMessage({id: "hkidr.yes"}) : intl.formatMessage({id: "hkidr.no"})
                }
                
              </Grid>

              {
                !this.props.accountType.split(',').includes("JOIN") &&  this.state.filename &&
                <React.Fragment>
                  <Grid item xs={6}>
                    <span><FormattedMessage id={"hkidr.docType"} />:</span>
                  </Grid>
                  <Grid item xs={6}>
                    <span><FormattedMessage id={"hkidr." + this.state.docType} /></span>
                  </Grid>

                  <Grid item xs={6}>
                    <span><FormattedMessage id="hkidr.idIssuePlace" />:</span>
                  </Grid>
                  <Grid item xs={6}>
                    <span>{this.state.issuePlaceText}</span>                    
                  </Grid>

                  <Grid item xs={6}>
                    <span><FormattedMessage id={this.state.docType == "NTID" ? "hkidr.NTIDF" : "hkidr.doc"} />:</span>
                  </Grid>
                  <Grid item xs={6}>
                    <span style={{wordBreak:"break-word"}}>{this.state.filename}</span>
                  </Grid>

                  {
                    this.state.docType == "NTID" &&
                    <React.Fragment>
                      <Grid item xs={6}>
                        <span><FormattedMessage id="hkidr.NTIDB" />:</span>
                      </Grid>
                      <Grid item xs={6}>
                        <span style={{wordBreak:"break-word"}}>{this.state.backsideFilename}</span>
                      </Grid>
                    </React.Fragment>
                  }

                </React.Fragment>
              }
              {
                this.props.accountType.split(',').includes("JOIN") &&  this.state.fileUploadList.length > 0 &&
                <React.Fragment>
                  <TableContainer>
                            <Table aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b><FormattedMessage id="hkidr.docType" /></b></TableCell>
                                        <TableCell><b><FormattedMessage id="hkidr.doc" /></b></TableCell>                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        this.state.fileUploadList.map((record, index) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <span><FormattedMessage id={"hkidr." +record.documentType} /></span>
                                                </TableCell>
                                                <TableCell>
                                                  <div>{record.fileName}</div>
                                                  {
                                                    record.documentType == "NTID" &&
                                                      <div>{record.bsFileName}</div>
                                                  }
                                                  </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                </React.Fragment>
              }
              
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus disabled={this.state.confirmDialogShowProgress} onClick={this.handleConfirmDialogCancel} color="primary">
              <FormattedMessage id="general.cancel" />
            </Button>
            <Button disabled={this.state.confirmDialogShowProgress} onClick={this.handleConfirmDialogOK} color="primary">
              <FormattedMessage id="general.ok" />
            </Button>
          </DialogActions>
          { 
            this.state.confirmDialogShowProgress && 
            <div style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
              <CircularProgress />
            </div>
          }
        </Dialog>


            {/* result dialog */}
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={this.state.resultOpen}
        >
          <DialogTitle>              
            <FormattedMessage id="hkidr.result" />
          </DialogTitle>
          <DialogContent dividers>
            {
              this.props.submitResult ? 
              <span> <FormattedMessage id="hkidr.success" /></span>:<span> <FormattedMessage id="hkidr.fail" /></span> 
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleResultDialogClose} color="primary">
              <FormattedMessage id="general.close" />
            </Button>
          </DialogActions>
          { 
            this.state.confirmDialogShowProgress && 
            <div style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
              <CircularProgress />
            </div>
          }
        </Dialog>
          <hr style={{width:"100%"}} />
        
        <div><span style={{fontFamily: "Roboto, Helvetica, Arial, sans-serif"}}><FormattedMessage id="general.notes" /> :</span></div>
        
        <div>
          <ol>
            <li><FormattedMessage id="hkidr.remark1" /></li>
            <li><FormattedMessage id="hkidr.remark2" /></li>
            <li><FormattedMessage id="hkidr.remark3" /></li>
            <li><FormattedMessage id="hkidr.remark4" /></li>
          </ol>
        </div>


        </Grid>
        }

        {
          this.state.showResultPage &&
          <div>
            <span><FormattedMessage id="hkidr.consented" /></span> 
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {    
    captcha: state.hkidrReducer.captcha,
    verifyAccountResult: state.hkidrReducer.verifyAccountResult,
    accountType: state.hkidrReducer.accountType,
    accountInfo: state.hkidrReducer.accountInfo,
    countryList: state.hkidrReducer.countryList,
    submitResult: state.hkidrReducer.submitResult,
    notConsent: state.hkidrReducer.notConsent,
    consentStatusCompleted:state.hkidrReducer.consentStatusCompleted,
    accountTypeCompleted:state.hkidrReducer.accountTypeCompleted
  };
}

export default connect(mapStateToProps, {submitHKIDR,fetchAccountType,fetchCaptcha,fetchCountryList,verifyAccount,fetchConsentStatus,fetchAccountInfo })(injectIntl(HKIDRForm));
